export const TAC_URL = "https://kolmeo.com/terms-conditions/";

export const REQ_CALLBACK_URL = {
  TERMS_URL: "https://www.rent.com.au/rentconnect/terms_and_conditions",
  POLICY_URL: "https://connectnow.com.au/privacy-policy",
  PRIVACY_MAIL: "mailto:privacy@connectnow.com.au"
};
